import React from "react";

function SeloPopupPublico({ selos, dadosSelos, onClose }) {
  return (
    <div className="popup-selos-overlay">
      <div className="popup-selos">
        <button className="popup-fechar" onClick={onClose} title="Fechar">×</button>

      
        <div className="usuario-info2">PINS CONQUISTADOS</div>
        <p className="info">
          Estes são os pins que este Termometeiro já conquistou!
        </p>

        <div className="lista-selos">
          {selos && selos.length > 0 ? (
            selos.map((seloId) => {
              const dados = dadosSelos[seloId];
              if (!dados) return null;

              return (
                <div
                  key={seloId}
                  className="item-selo2"
                  title={dados.motivo || 'Selo sem descrição'}
                >
                  <img src={dados.imagemUrl} alt={dados.nome} />
                  <p className="motivo-selo">{dados.motivo}</p>
                </div>
              );
            })
          ) : (
            <p className="info">Este usuário ainda não conquistou pins.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SeloPopupPublico;